import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Icon, Link } from '@chakra-ui/react';
import { routes } from 'app/routing/routesConfig';
import { notificationsButtonSx } from 'app/components/HeaderBar/NotificationsButton/styles';
import { ReactComponent as BellIcon } from 'resources/images/bell.svg';
import { ReactComponent as BellActiveIcon } from 'resources/images/bell-active.svg';
import { BadgeCounter } from 'app/components/Core/BadgeCounter';

interface NotificationsButtonProps {
  notificationsCount: number;
}

const NotificationIcon = ({ notificationsCount }: NotificationsButtonProps) => {
  return (
    <Box position="relative">
      {notificationsCount > 0 ? (
        <>
          <Icon
            as={BellActiveIcon}
            aria-label="new notifications"
            sx={{
              width: 9,
              height: 9,
              '& circle': {
                stroke: 'B.0',
                fill: 'none',
              },
              '& path': {
                fill: 'M.60',
              },
            }}
          />
          <BadgeCounter
            position="absolute"
            top="0"
            right="-6px"
            count={notificationsCount}
          />
        </>
      ) : (
        <BellIcon />
      )}
    </Box>
  );
};

export const NotificationsLinkButton: React.FC<NotificationsButtonProps> = ({
  notificationsCount = 0,
}: NotificationsButtonProps) => {
  return (
    <Link
      data-testid="notifications"
      aria-label="Notifications"
      to={routes.notifications.path}
      as={RouterLink}
      sx={notificationsButtonSx.button}
    >
      <NotificationIcon notificationsCount={notificationsCount} />
    </Link>
  );
};
